import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { TippspielState } from './state';

const defaultState: TippspielState = {
  matches: [],
  leaderboard: [],
};

export const tippspielStore = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
